<template>
	<header>
		<div class="bacontent">
			<div class="bap">网上考试报名系统</div>
			<div class="bright">
				<el-link class="brightp" :underline="false" @click="pwdupdate"><i
						class="el-input__icon el-icon-s-order"></i>修改密码</el-link>
				<el-link class="brightp" :underline="false" @click="xieyi"><i
						class="el-input__icon el-icon-warning"></i>报名须知</el-link>
				<el-link class="brightp" :underline="false" @click="exit"><i
						class="el-input__icon el-icon-right"></i>退出</el-link>
			</div>
		</div>
	</header>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		created() {
			if (this.$store.state.firstdo == -1) {
				this.$router.push('/register')
			}
		},
		methods: {
			pwdupdate() {
				this.$router.push({
					path: '/fortpas'
				})
			},
			xieyi() {
				this.$router.push({
					path: '/xieyi'
				})

			},
			exit() {
				this.$store.commit('updateToken', '');
				this.$store.commit('modifyfirstdo', -1);
				this.$router.push({
					path: '/Register'
				})

			}
		}

	}
</script>

<style>
	header {
		height: 120px;
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		margin-top: -20px;
	}

	.bacontent {
		width: 1200px;
		margin: 0 auto;
	}

	.bap {
		color: #ffffff;
		float: left;
		line-height: 130px;
		letter-spacing: 2px;
		text-shadow: #333333 0px 0px 5px;
		font-size: 26px;
	}

	.bright {
		float: right;
	}

	.brightp {
		line-height: 130px;
		color: #FFFFFF !important;
		font-size: 16px;
		margin-left: 20px;
		list-style: none;
	}

	.brightp i {
		font-size: 20px;
	}
</style>